/**
 * @typedef {"FLAT"|"STEEP"|"FLAT2"|"STEEP2"} MeridianStr The name of a meridian.
 */

/**
 * The parameters of a segment in an advanced lens order form.
 */
export default class AdvancedLensFormSegment
{
    // ------------------------------------------------------------ MEMBERS

    /**
     * The meridian of the segment.
     * @type {MeridianStr}
     */
    meridian = 'FLAT';

    /**
     * The zone of the segment.
     * @type {?string}
     */
    zone = null;

    /**
     * The type of the segment.
     * @type {?string}
     */
    type = null;

    /**
     * The diameter of the segment.
     * @type {?number}
     */
    diameter = null;

    /**
     * The radius of the segment.
     * @type {?number}
     */
    radius = null;

    /**
     * The eccentricity of the segment.
     * @type {?number}
     */
    eccentricity = null;

    /**
     * The sagittal of the segment.
     * @type {?number}
     */
    sagittal = null;


    // ------------------------------------------------------------ CONSTRUCTOR

    /**
     * Construct a new AdvancedLensFormSegment.
     *
     * @param {?MeridianStr} meridian
     * @param {?string} zone
     * @param {?string} type
     * @param {{
     *     diameter?:     ?number,
     *     radius?:       ?number,
     *     eccentricity?: ?number,
     *     sagittal?:     ?number,
     * }} params
     */
    constructor(meridian, zone, type, {
        diameter     = null,
        radius       = null,
        eccentricity = null,
        sagittal     = null,
    } = {})
    {
        this.meridian     = meridian;
        this.zone         = zone;
        this.type         = type;
        this.diameter     = diameter;
        this.radius       = radius;
        this.eccentricity = eccentricity;
        this.sagittal     = sagittal;
    }
}
